import { Control } from 'react-hook-form';
import { Toggle } from '@/components/ui/Toggle';
import { Award } from 'lucide-react';

interface CertificationSettingsSectionProps {
  control: Control<any>;
}

export default function CertificationSettingsSection({
  control,
}: CertificationSettingsSectionProps) {
  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-6">
        <Award className="w-5 h-5 text-blue-600" />
        <h2 className="text-lg font-semibold">Certification Settings</h2>
      </div>
      <div className="space-y-6">
        <Toggle
          name="allow_learner_certificate_regeneration"
          control={control}
          label="Allow Learner Certificate Regeneration"
          description="When enabled, learners can regenerate their own certificates (e.g., after a name change). When disabled, only admins can regenerate."
        />
      </div>
    </div>
  );
}
